let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dMOc8")).then(() => parcelRequire('5XpHP'));